import { X } from "lucide-react";
import { useEffect } from "react";

export default function Modal({ open, onClose, title, subtitle, wide, children, footer, testId = "modal" }) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => e.key === "Escape" && onClose?.();
        document.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    if (!open) return null;
    return (
        <div className="zentra-modal-overlay" onClick={onClose} data-testid={`${testId}-overlay`}>
            <div
                className={`zentra-modal ${wide ? "zentra-modal-wide" : ""}`}
                onClick={(e) => e.stopPropagation()}
                data-testid={testId}
            >
                <div className="px-6 py-5 border-b border-zentra-border flex items-start justify-between gap-4">
                    <div>
                        <h3 className="font-display font-semibold text-xl text-zentra-ink tracking-tight">
                            {title}
                        </h3>
                        {subtitle && <p className="text-sm text-zentra-muted mt-1">{subtitle}</p>}
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-zentra-muted hover:text-zentra-ink transition"
                        data-testid={`${testId}-close`}
                        aria-label="Cerrar"
                    >
                        <X size={20} />
                    </button>
                </div>
                <div className="px-6 py-5">{children}</div>
                {footer && (
                    <div className="px-6 py-4 border-t border-zentra-border bg-zentra-bg/40 flex items-center justify-end gap-3 rounded-b-[14px]">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
}
